import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin } from 'lucide-react';
import { formatCurrency } from '@/lib/formatUtils';
import type { PlatformSales } from '@/types/dashboard';

interface SalesChannelCardProps {
  platforms: PlatformSales[];
  footerText?: string;
}

export const SalesChannelCard: React.FC<SalesChannelCardProps> = ({
  platforms,
  footerText = 'Gross profit reflects platform payout after deductions, minus COGS.',
}) => {
  return (
    <Card className="bg-card">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <MapPin className="h-4 w-4 text-muted-foreground" />
          <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Where Did I Sell
          </span>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs text-muted-foreground">
                <th className="text-left pb-3 font-medium">Platform</th>
                <th className="text-right pb-3 font-medium">Net Sales</th>
                <th className="text-right pb-3 font-medium">Tickets</th>
                <th className="text-right pb-3 font-medium">ATP</th>
                <th className="text-right pb-3 font-medium">Comm %</th>
                <th className="text-right pb-3 font-medium">Payout</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {platforms.map((p) => (
                <tr key={p.platform}>
                  <td className="py-2.5 font-medium text-foreground">{p.platform}</td>
                  <td className="py-2.5 text-right font-mono font-semibold">{formatCurrency(p.netSales)}</td>
                  <td className="py-2.5 text-right font-mono">{p.tickets.toLocaleString()}</td>
                  <td className="py-2.5 text-right font-mono">{formatCurrency(p.avgTicketPrice)}</td>
                  <td className="py-2.5 text-right font-mono">{p.commissionPercent.toFixed(1)}%</td>
                  <td className="py-2.5 text-right font-mono">{(p.payoutRatio * 100).toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {footerText && (
          <p className="text-xs text-muted-foreground mt-4">
            {footerText}
          </p>
        )}
      </CardContent>
    </Card>
  );
};
